import React from 'react';

const FormTitle = (props: { title: string }) => {
  return <h2 className="card-title justify-center text-3xl">{props.title}</h2>;
};

export default FormTitle;
